

















import { ValidationProvider } from 'vee-validate';
import type { WithRefs } from 'vue-typed-refs';
import { ValidatableMixin } from '../../mixins';
import SldsComboBox from '../ComboBox/ComboBox.vue';

export type Refs = {
  combobox: InstanceType<typeof SldsComboBox>;
};

export default (
  ValidatableMixin as WithRefs<Refs, typeof ValidatableMixin>
).extend({
  name: 'AppValidateableTextField',
  components: {
    ValidationProvider,
    SldsComboBox,
  },
  inheritAttrs: false,
});
